// src/services/setting.service.js

import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.REACT_APP_API_SERVER;

class SettingService {
    // Lấy toàn bộ settings (admin)
    getAll() {
        return axios.get(`${API_URL}/admin/settings`, { headers: authHeader() });
    }

    // Cập nhật setting theo key (admin)
    update(key, value) {
        return axios.put(`${API_URL}/admin/settings/${key}`, { value }, { headers: authHeader() });
    }
}

export default new SettingService();
